import { useCallback } from 'react';
import Joyride, { type CallBackProps, STATUS } from 'react-joyride';

import steps from './steps';

import { Step } from '@cobliteam/api-lib';

import { Analytics } from '@cobliteam/analytics';
import {
  useOnboardingStore,
  useUpdateOnboarding,
  useUpdateOnboardingStore,
} from '@cobliteam/onboarding';

import { CardTour } from '../../../components/Tour';

export default function AlertsTour() {
  const [tourStepsIndex, setTourStepsIndex] = useOnboardingStore((state) => [
    state.tourStepsIndex,
    state.setTourStepsIndex,
  ]);

  const setTourReset = useOnboardingStore((state) => state.setTourReset);

  const [alertsTour, setAlertsTourFinish] = useOnboardingStore((state) => [
    state.alertsTour,
    state.setAlertsTourFinish,
  ]);

  const onboardingStepName = useOnboardingStore(
    (state) => state.onboardingStepName
  );

  const { endStep } = useUpdateOnboarding();
  const { getOnboardingStepStore } = useUpdateOnboardingStore();
  const onboardingStep = getOnboardingStepStore(Step.ALERT_CONFIG);

  const handleTourCallback = useCallback(
    (data: CallBackProps) => {
      const { action, lifecycle, status } = data;

      if (action === 'close' && lifecycle === 'complete')
        setTourStepsIndex(tourStepsIndex + 1);
      if (action === 'next' && lifecycle === 'complete')
        setTourStepsIndex(tourStepsIndex + 1);
      if (action === 'prev' && lifecycle === 'complete')
        setTourStepsIndex(tourStepsIndex - 1);

      if (status === STATUS.SKIPPED) {
        setAlertsTourFinish();
        setTourReset();
        Analytics.track('Onboarding Dismissed', {
          context: `${onboardingStepName} step ${tourStepsIndex}`,
        });
      }

      if (status === STATUS.FINISHED) {
        endStep(onboardingStep);
        setAlertsTourFinish();
        Analytics.track('Onboarding Alerts Task Concluded');
      }
    },
    [setTourStepsIndex, tourStepsIndex]
  );

  return (
    <Joyride
      callback={handleTourCallback}
      continuous
      disableScrolling
      disableScrollParentFix
      run={alertsTour}
      steps={steps}
      styles={{
        options: {
          zIndex: 1400,
        },
      }}
      tooltipComponent={CardTour}
    />
  );
}
